import React, { useState } from "react"
import { Checkbox, Text, Flex, Box, Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react"
import Icon from "@components/Icon/Icon"
import Swatch from "./Swatch"

const FilterList: React.FC = (props: any) => {
  const [isOpen, setIsOpen] = useState(false)

  const buildTextLabel = (label: string, replace: boolean) => {
    const sizeMap = {
      "1KG": "1kg (0000000)",
      "2KG": "2kg (000000)",
      "3KG": "3kg (00000)",
      "4KG": "4kg (0000)",
      "0000": "NB (0000)",
      "000": "0-3m (000)",
      "00": "3-6m (00)",
      "6-12m": "6-12m (0)",
      0: "6-12m (0)",
      1: "12-18m (1)",
      2: "18-24m (2)",
    }

    if (typeof label === "number") {
      return label
    }

    if (sizeMap[label]) {
      return sizeMap[label]
    }

    if (replace) {
      return label.replace(/-/g, " ")
    }

    return label
  }

  return (
    <Flex position="relative">
      <Accordion w="100%" allowToggle={true}>
        <AccordionItem w="100%">
          <AccordionButton w="100%" _hover={{ backgroundColor: `transparent` }}>
            <Flex w="100%" fontSize="15px" alignItems={"center"} onClick={() => setIsOpen(!isOpen)} cursor="pointer">
              <Text fontWeight={props.filterListProps.totalSelected ? "600" : "normal"}>{props.filter.name}</Text>
              <Text pl={1} fontWeight="light" color="text.secondary" transform={`translateY(2px)`}>
                {props.filterListProps.totalSelected > 0 ? `(${props.filterListProps.totalSelected})` : ""}
              </Text>
              <Box ml="auto" transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
                <Icon ml="10px" name="chevronDown" size="14px" color="black"></Icon>
              </Box>
            </Flex>
          </AccordionButton>
          <AccordionPanel pb={1} overflow={"auto"}>
            <Flex py={1} flexDirection={"column"}>
              {props.filterListProps.options.map((option: any) => (
                <Flex
                  onClick={() => {
                    props.filterListProps.handleChange(option.key)
                  }}
                  textTransform={"capitalize"}
                  py={1}
                  cursor="pointer"
                  key={option?.key}
                  fontWeight="medium"
                  whiteSpace={"nowrap"}
                  fontSize={"12px"}
                  alignItems={`center`}
                >
                  {props?.filter?.displayView === "swatch" ? (
                    <Swatch {...option} />
                  ) : (
                    <Checkbox pointerEvents={"none"} isChecked={option.checked} mr={1}></Checkbox>
                  )}
                  {buildTextLabel(option.key, props?.filter?.name === "Benefits")}
                </Flex>
              ))}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}

export default FilterList
